import { useState } from 'react';
import { observer } from 'mobx-react';
import { Alert, Grid, Box, Paper, Typography, TextField, Stack } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import styles from './wallet.module.scss'
import RoundButton from '../shared/components/round-btn';
import { useFormik } from 'formik';
import ContactSchema from '../shared/forms-schemas/contact-schema';

const ContactUs = observer(() => {
    const [, setLoading] = useState(false);
    const [showSuccess, setShowSucess] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',
            name: '',
            message: ''
        },
        validationSchema: ContactSchema,
        onSubmit: async (values) => {
            setLoading(true)
            setShowSucess(true);
            setLoading(false);
        },
    });

    return (
        <>
            <Header></Header>
            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="h6" color='#242333' fontWeight={700}>Contact Us</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: 'center', mt: 2 }}>
                        {showSuccess ?
                            <Alert sx={{width: '100%'}} severity='success'>Email has been sent successfully</Alert>
                            :
                            <Paper variant="round" sx={{ p: 4, width: '100%' }}>
                                <Typography sx={{ mb: 2 }}>Please use the following form to contact us:</Typography>
                                <Box
                                    component="form"
                                    onSubmit={formik.handleSubmit}
                                >
                                    <Stack spacing={3}>
                                        <TextField
                                            fullWidth
                                            required
                                            id="name"
                                            label="Name"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.name && Boolean(formik.errors.name)}
                                            helperText={formik.touched.name && formik.errors.name}
                                        />

                                        <TextField
                                            fullWidth
                                            required
                                            id="email"
                                            label="Email Address"
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.email && Boolean(formik.errors.email)}
                                            helperText={formik.touched.email && formik.errors.email}
                                        />

                                        <TextField
                                            fullWidth
                                            required
                                            id="message"
                                            label="Message"
                                            minRows={5}
                                            multiline
                                            value={formik.values.message}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.message && Boolean(formik.errors.message)}
                                            helperText={formik.touched.message && formik.errors.message}
                                        />
                                    </Stack>


                                    <Box sx={{ display: "flex", justifyContent: 'flex-end', mt: 2 }}>
                                        <RoundButton
                                            size="large"
                                            variant="contained"
                                            sx={{ height: 'fit-content', mt: 2 }}
                                            type='submit'
                                        >
                                            Send
                                        </RoundButton>
                                    </Box>

                                </Box>
                            </Paper>
                        }
                    </Box>
                </Box>
            </Grid>
            <Footer></Footer>
        </>
    );
});

export default ContactUs;